import React from 'react';
// 引入 core 和 React 组件
import { Swiper, SwiperSlide } from 'swiper/react';
// 引入需要的模块
import { Pagination, Autoplay } from 'swiper/modules';
// 引入样式（如果你没在全局样式中引入，也可以在此处引入）
import 'swiper/css';
import 'swiper/css/pagination';
const ImageCarousel = ({ images, width = 600, height = 'auto' }) => {
  return (
    <Swiper
      // 安装模块
      modules={[Pagination, Autoplay]}
      style={{ width, height, flexShrink: 0 }}
      spaceBetween={30}
      className=''
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000, disableOnInteraction: false }}
      loop={true}
    >
      {/* 每个 SwiperSlide 即一个滑块 */}
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            src={image}
            alt={`Slide ${index + 1}`}
            width={'100%'}
            height={'100%'}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageCarousel;
